<template>
	<div class="popup-form__wrap">
		<transition name="fade-popup-form" appear>
			<div class="popup-form">
				<div class="popup-form__overlay" @click="closePopup"></div>
				<div class="popup-form__box">
					<span class="popup-form__title section-title">
						<span class="popup-form-title" v-if="data.popupTitle">{{ data.popupTitle }}</span>
					</span>
					<div class="popup-form__inner">
						<PartCalendar
							v-if="data.showCalendar"
							:data="data.DataCalendar"
							v-model="popupInner.datepicker"
						/>
						<PartInputTextarea
							:data="data.DataNoteArea"
							v-model="popupInner.note"
							ref="formTextArea"
						/>
						<a class="btn popup-form__btn" :id="data.popupButtonId" @click="submitForm()">Submit</a>
						<div class="popup-form__wrap-close-popup">
							<a href="javascript:" @click="closePopup">
								<SvgIcon class="close-icon" iconName="ico-close-sm"/>
							</a>
						</div>
					</div>
				</div>
			</div>
		</transition>
    </div>
</template>

<script>
import { mixin as onClickOutside } from 'vue-on-click-outside';
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import PartCalendar from '@/components/parts/PartCalendar';
import PartInputTextarea from '@/components/parts/PartInputTextarea';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			popupInner: {
				datepicker: '',
				note: ''
			}
		};
	},
	components: {
		SvgIcon,
		PartCalendar,
		PartInputTextarea
	},
	mounted() {
		this.$refs.formTextArea.$refs.inputArea.focus();
	},
	mixins: [onClickOutside],
	methods: {
		closePopup() {
			this.$emit('closePopupForm');
			this.popupInner.datepicker = '';
			this.popupInner.note = '';
		},
		submitForm() {
			this.$emit('submitForm', this.popupInner);
			this.popupInner.datepicker = '';
			this.popupInner.note = '';
		}
	}
};
</script>

<style lang="scss" scoped>
.popup-form__overlay {
	position: fixed;
    top: 0;
    left: 0;
	bottom: 0;
	right: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-color: rgba($slate-gray, .5);
}

.popup-form__box {
	z-index: 101;
}

.popup-form__wrap {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 9999999;
    display: flex;
    justify-content: center;
    align-items: center;
}
.popup-form {
    max-width: 475px;
    padding: 23px 27px 50px 21px;
    width: 100%;
    background-color: $white;
    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 4px rgba($black, .25);
    border-radius: 8px;
    position: relative;
	overflow-y: auto;
	max-height: 60vh;

	&::-webkit-scrollbar {
		width: 12px;
		height: 12px;
	}

	&::-webkit-scrollbar-track {
		background: #eceeef;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #42526e;
		border-radius: 20px;
		border: 1px solid #eceeef;
	}
	scrollbar-width: thin;
	scrollbar-color: #42526e #eceeef;

    @include mq($lg) {
        padding: 40px 30px;
    }

    @include mq($sm) {
        padding: 40px 15px;
    }
}

.popup-form__title {
    margin-bottom: 14px;
    font-size: 20px;

    @include mq($lg) {
        font-size: 18px;
        margin-bottom: 20px;
    }

    @include mq($md) {
        font-size: 16px;
    }

    @include mq($sm) {
        font-size: 15px;
    }
}

.popup-form-title {
	font-family: $font-second;
	font-weight: 500;
	font-size: 20px;
	line-height: 23px;
	color: $fiord;
	text-align: left;
}

.popup-form__inner {
    display: flex;
	flex-direction: column;
    max-width: 100%;
    width: 100%;
}

.popup-form__btn {
    margin-left: auto;
    max-width: 96px;
    display: flex;
}

.close-icon {
    position: absolute;
    right: 15px;
    top: 15px;
	color: $fiord;
	font-size: 20px;
	transition: $dur $ease;
	cursor: pointer;

	@include hover {
		color: $dodger-blue;
	}
}
</style>
